

















































import {Component, Ref, Vue, Watch, Prop, Emit} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {WebRTCRequest, WebRTCRequestState} from '@/store/Friends/types';
import {DateTime} from 'luxon';
// @ts-ignore
import * as firebase from 'firebase/app';
import * as _ from 'lodash';
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;
import { UserTransaction } from '../../../store/User/types';

const userNamespace = namespace('userState');
const friendNamespace = namespace('friendState');
const rateNamespace = namespace('rateState');

@Component({
  components: {
    BButton,
  },
})
/* tslint:disable:no-console */
/* tslint:disable:max-line-length */
/* tslint:disable:no-empty */
export default class VideoChatModal extends Vue {
  @Prop() public readonly incomingConnection!: WebRTCRequest;
  @Prop() public readonly incomingUser!: MAFUser;
  @Prop() public readonly chatType!: string;

  @userNamespace.State('self') public self!: MAFUser;
  @friendNamespace.Action('sendP2PConnection') public sendP2PConnection!: any;
  @friendNamespace.Getter('getLatestConnection') public getLatestConnection!: WebRTCRequest;
  @friendNamespace.Action('getFriendTransactions') public getFriendTransactions!: any;
  @friendNamespace.Action('sendEmailNotification') public sendEmailNotification!: any;
  @friendNamespace.State('transactions') public readonly transactions!: UserTransaction[];

  @Ref('yourVideo') public yourVideo!: HTMLVideoElement;
  @Ref('friendsVideo') public friendsVideo!: HTMLVideoElement;

  public ringing: boolean = false;
  public hasRung = false;
  public state: WebRTCRequestState = WebRTCRequestState.Requested;
  public currentRTC: WebRTCRequest | undefined;
  public callStarted: boolean = false;
  public callReceived: boolean = false;
  public callAccepted: boolean = false;
  public callEnded: boolean = false;
  public disableCall: boolean = false;
  public friendId: string | undefined;
  public coinsGift: number = 0;

  // call connection configuration
  public iceUrl: string = process.env.WEB_RTC_STUN_URL ? process.env.WEB_RTC_STUN_URL : 'numb.viagenie.ca';
  public iceUN: string = process.env.WEB_RTC_STUN_UN ? process.env.WEB_RTC_STUN_UN : 'michael.leffert@seisan.com';
  public icePW: string = process.env.WEB_RTC_STUN_PW ? process.env.WEB_RTC_STUN_PW : 'L3tMeIn!';
  public servers: RTCConfiguration;
  public myIce: RTCIceCandidate[] = [];
  public audio: HTMLAudioElement = new Audio(require('../../../assets/phonering.mp3'));
  public pc: RTCPeerConnection;

  get hasAudio() {
    const hasAudio = _.find(this.transactions, (t: UserTransaction) => {
      return t.purchase.what === 'audio';
    });
    return !!hasAudio;
  }

  get hasVideo() {
    const hasVideo = _.find(this.transactions, (t: UserTransaction) => {
      return t.purchase.what === 'video';
    });
    return !!hasVideo;
  }

  // set up server connection for video chatting
  constructor() {
    super();
    this.servers = {
      iceServers: [{urls: `stun:${this.iceUrl}`}, {urls: `stun:${this.iceUrl}`}, {
        urls: `turn:${this.iceUrl}`,
        credential: this.icePW,
        username: this.iceUN,
      }],
    };
    this.pc = new RTCPeerConnection(this.servers);
  }

  public async mounted() {
    const self = this;
    await this.getFriendTransactions(this.incomingUser.uid);
    // establish connection coming from self
    this.pc.onicecandidate = (async (event) => {
      if (event.candidate) {
        if (self.callStarted && self.currentRTC && self.currentRTC.Reference) {
          self.currentRTC.Reference.collection(self.currentRTC.sender === self.self.uid ? 'sender' : 'to').add(JSON.parse(JSON.stringify(event.candidate)));
        }
      } else {
        console.log('sent all ice');
      }
    });
    // @ts-ignore

    if (this.chatType === 'Video') {
      this.pc.ontrack = ( (event: any) => this.friendsVideo.srcObject = event.stream);
      this.showMyFace();
    }
  }

  public beforeDestroy() {
    this.endCall();
  }

  // delete current 'to' or 'from' (subId) requests
  public setIce(id: string, subId: string) {
    const self = this;
    this.$firestore.collection(`p2pconnections/${id}/${subId}`).onSnapshot((snapshot: QuerySnapshot) => {
      snapshot.forEach((doc: QueryDocumentSnapshot) => {
        const ice = JSON.parse(JSON.stringify(doc.data()));
        self.pc.addIceCandidate(new RTCIceCandidate(ice));
        doc.ref.delete().then(() => console.log('deleted'));
      });
    }, (error: any) => {
       if (Vue.prototype.$auth.currentUser !== null) {
          console.log(`Error getting chat connections: ${error}`);
        }
    });
  }

  public sendOffer() {
    const self = this;
    if (self.state === WebRTCRequestState.Accepted) {
      self.state = WebRTCRequestState.Connecting;
      if (self.currentRTC) {
        if (self.currentRTC.Reference) {
          self.setIce(self.currentRTC.Reference.id, 'to');
        }
        self.pc.createOffer()
          .then((offer) => self.pc.setLocalDescription(offer))
          .then(() => {
            if (self.currentRTC) {
              self.currentRTC.state = WebRTCRequestState.Connecting;
              self.currentRTC.sdp = self.pc.localDescription;
              self.currentRTC.updateWebRTC();
            }
          });
      }
    }
  }

  // start video for myself
  public showMyFace() {
    const self = this;
    const videoSettings = ( this.chatType === 'Video' ) ? {width: 1280, height: 720, facingMode: 'user'} : false;
    navigator.mediaDevices.getUserMedia({audio: true, video: videoSettings})
    .then((stream) => {
      // only show video if it's a video call
      if (this.chatType === 'Video') {
        self.yourVideo.srcObject = stream;
        // @ts-ignore
        self.pc.addStream(stream);
      }
    });
  }

  // show my friend's face - this only happens once they accept the call
  public async startCall() {
    this.disableCall = true;
    const self = this;
    this.friendId = (this.incomingUser) ? this.incomingUser.uid : this.friendId;
    const isVideo = (this.chatType === 'Video');
    const isAudio = (this.chatType !== 'Video');
    self.currentRTC = new WebRTCRequest(null, this.friendId, self.self.uid, null, DateTime.local().toJSDate(), null, isVideo, isAudio);

    try {
      await this.sendP2PConnection(self.currentRTC);
      this.callStarted = true;
    } catch (error) {
      console.log(error);
    }
  }

  // accept call request
  public acceptOffer() {
    this.stopRinging();

    const self = this;
    this.callAccepted = true;

    if (self.currentRTC && self.currentRTC.Reference) {
      self.setIce(self.currentRTC.Reference.id, 'sender');
      self.currentRTC.state = WebRTCRequestState.Accepted;
      self.currentRTC.updateWebRTC();
    }
  }

  // decline call request
  public declineOffer() {
    this.stopRinging();
    this.endCall();
  }

  public endCall() {
    // there is a connection
    if (this.currentRTC) {
      // the connection has not yet ended
      if (this.currentRTC.state !== WebRTCRequestState.Ended) {
        // if it's ending, end - if not, start process for ending
        this.currentRTC.state = (this.currentRTC.state === WebRTCRequestState.Ending) ? WebRTCRequestState.Ended : WebRTCRequestState.Ending;
        this.currentRTC.updateWebRTC();
      }
    }

    // reset
    if ( this.pc ) {
      this.pc.close();
    }

    if (this.chatType === 'Video') {
      this.yourVideo.srcObject = null;
      this.friendsVideo.srcObject = null;
    }

    this.disableCall = false;
    this.ringing = false;
    this.callStarted = false;
    this.callReceived = false;
    this.callAccepted = false;
    this.callEnded = true;
  }

  public reportFriend() {
    // end call
    this.stopRinging();
    this.endCall();

    // grab friend information
    const friend = this.incomingUser;

    // report friend stating inappropriate video or audio chat
    this.showReporting(friend);

    // close video chat modal
    this.closeChat();
  }

  @Emit('showReportUser')
  public showReporting(friend: MAFUser) {
    return friend;
  }

  @Emit('closeChat')
  public closeChat() {
  }

  public blockFriend() {
    // end call
    this.stopRinging();
    this.endCall();

    // grab friend information
    const friend = this.incomingUser;

    // block connection between friends
    this.showBlocking(friend);

    // close video chat modal
    this.closeChat();
  }

  @Emit('showBlockedUser')
  public showBlocking(friend: MAFUser) {
    return friend;
  }

  @Watch('incomingUser', { deep: true })
  public getIncomingUser() {
    // only update if it's different, otherwise causes infinite loop
    if (this.incomingUser.uid !== this.friendId) {
      this.friendId = this.incomingUser.uid || '';
      // this.showFriendsFace();
    }
  }

  @Watch('incomingConnection' , { deep: true })
  public getIncomingConnection(data: any) {
    if (this.incomingConnection !== this.currentRTC) {
      this.currentRTC = this.incomingConnection;
      // this.loopRinging();
      // this.ringing = true;
    }

    if (this.incomingConnection.state === WebRTCRequestState.Requested && !this.callAccepted) {
      this.ringing = true;
      this.loopRinging();
    }
  }

  @Watch('getLatestConnection')
  public readMessage(data: any) {
    if (this.getLatestConnection) {
      const self = this;
      self.currentRTC = self.getLatestConnection;
      const sender = self.currentRTC.sender;

      // if the state is "Ended", we don't do anything
      console.log('getting a call change');

      // call is "Ending" - end it
      if (self.currentRTC.state === WebRTCRequestState.Ending || self.currentRTC.state === WebRTCRequestState.Ended) {
        console.log('call ending');
        self.endCall();
        self.stopRinging();
      }

      // you're the friend receiving the call
      if (sender !== self.self.uid) {
        // do we want this here?
        // self.ringing = true;

        // call requested of them, not accepted yet
        if (self.currentRTC.state === WebRTCRequestState.Requested) {
          self.callStarted = false; // you're not the ones who started the call
          self.callEnded = false;
          self.callReceived = true;
          self.callAccepted = false; // just in case
          self.loopRinging();
          console.log('receiving - incoming call');
        } else if (self.currentRTC.state === WebRTCRequestState.Connecting && self.currentRTC.sdp) {
          // you have accepted a friend's call, create a connection
          if (self.getLatestConnection.sdp && self.getLatestConnection.sdp.type === 'offer') {
            console.log('receiving - connecting, creating connection');
            self.pc.setRemoteDescription(new RTCSessionDescription(self.getLatestConnection.sdp))
              .then(() => self.pc.createAnswer())
              .then((answer) => self.pc.setLocalDescription(answer))
              .then(() => {
                if (self.currentRTC) {
                  self.currentRTC.sdp = self.pc.localDescription;
                  self.currentRTC.updateWebRTC();
                }
              });
          } else if (self.getLatestConnection.sdp && self.getLatestConnection.sdp.type === 'answer') {
            // a connection was already created, you're just accepting
            console.log('receiving - answering');
            self.callReceived = false;
            self.callAccepted = true;
            self.stopRinging();
          }
        } else if (self.currentRTC.state === WebRTCRequestState.Accepted) {
          // you're accepting a call offer
          console.log('receivin - accepted');
          self.callAccepted = true;
          self.callReceived = false;
          self.stopRinging();
        }
      } else if (sender === self.self.uid) {
        // you're the user sending/creating the call
        // the call is connecting
        console.log('sending to friend');
        if (self.currentRTC.state === WebRTCRequestState.Connecting && self.currentRTC.sdp) {
          if (self.currentRTC.sdp.type === 'offer') {
            // your offer - friend has ended call
            self.callReceived = false;
            self.callAccepted = true;
            self.stopRinging();
          } else if (self.currentRTC.sdp.type === 'answer') {
            console.log('answering');
            self.callReceived = false;
            self.callAccepted = true;
            self.stopRinging();

            // updating RTC
            self.pc.setRemoteDescription(new RTCSessionDescription(self.currentRTC.sdp));
            self.currentRTC.state = WebRTCRequestState.Connected;
            self.currentRTC.updateWebRTC();
          }
        } else if (self.currentRTC.state === WebRTCRequestState.Accepted && self.state === WebRTCRequestState.Requested) {
          // you've requested a call that was just accepted
          // really weird way to intercept the friend ending the call
          self.state = self.currentRTC.state;
          self.sendOffer();
        } else if (self.currentRTC.state === WebRTCRequestState.Ending || self.currentRTC.state === WebRTCRequestState.Ended) {
          self.endCall();
        }
      }
    }
  }

  /**
   * The ringing sound that happens when someone is trying to initiate a call
   */

  public loopRinging() {
    this.audio.loop = true;
    this.audio.play();
    this.hasRung = true;
  }

  public stopRinging() {
    this.ringing = false;
    this.audio.pause();
    this.audio.currentTime = 0;
  }
}
